import { useRouteMatch } from "react-router-dom";
import App from "./App";

const UseRouter = (props) => {
  const match = useRouteMatch("/:lang/:layer?/:country?");
  return <App {...props} {...(match ? match.params : {})} />;
};

export default UseRouter;
